export { default as Img200 } from './processed/200/3_4.jpg';
export { default as Img400 } from './processed/400/3_4.jpg';
export { default as Img600 } from './processed/600/3_4.jpg';
export { default as Imgthumb } from './processed/thumb/3_4.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/3_4.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/3_4.jpg';
export const ImgData = { width: 366, height: 488, ratio: 1.3333333333333333, orientation: 'portrait' };
export const colors = {
  "Muted": {
    "_rgb": [
      124,
      124,
      124
    ],
    "_population": 4,
    "_hsl": [
      0,
      0,
      0.48627450980392156
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      196,
      196
    ],
    "_population": 2,
    "_hsl": [
      0,
      0,
      0.7686274509803922
    ]
  },
  "DarkMuted": {
    "_rgb": [
      67,
      67,
      67
    ],
    "_population": 14,
    "_hsl": [
      0,
      0,
      0.2627450980392157
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/3_4.js